import React, { useState } from 'react';
import { getBuildInfo } from '../utils/version';

const VersionInfo = ({ className = "", showDetails = false }) => {
  const [showBuildInfo, setShowBuildInfo] = useState(false);
  const buildInfo = getBuildInfo();
  
  const handleClick = () => {
    if (showDetails) {
      setShowBuildInfo(!showBuildInfo);
    }
  };
  
  return (
    <div className={`text-xs text-gray-400 ${className}`}>
      <span 
        className={showDetails ? "cursor-pointer hover:text-gray-600" : ""}
        onClick={handleClick}
        title={showDetails ? "Click for build details" : ""}
      >
        v{buildInfo.version}
      </span>
      
      {showDetails && showBuildInfo && (
        <div className="absolute bottom-full right-0 mb-2 p-2 bg-gray-800 text-white text-xs rounded shadow-lg z-50 min-w-max">
          <div>Version: {buildInfo.version}</div>
          <div>Build: #{buildInfo.buildNumber}</div>
          <div>Built: {new Date(buildInfo.buildTime).toLocaleString()}</div>
        </div>
      )}
    </div>
  );
};

export default VersionInfo;
